/* eslint no-unused-vars: 0 */

import React     from 'react';
import PropTypes from 'prop-types';
import { Link }  from 'react-router-dom';
import styles    from '../styles/header.styl';
import logo      from '../styles/logo.styl';

class Header extends React.Component {
  render() {
    if(this.props.authed) {
      return (
        <header className="header">
          <ul>
            <li className="app-headline">
              <Link to="/">
                <h1 className="purple-wipe">#BLESSED</h1>
              </Link>
            </li>
            <li className="app-rating nav-item">
              <Link to="/new">⭐️</Link>
            </li>
            <li className="app-profile nav-item">
              <Link to={ '/' + this.props.user.username} >👶</Link>
            </li>
            <li className="user-email">
              <span>{this.props.user.email}</span>
            </li>
          </ul>
        </header>
      );
    }
    return (
      <header className="header">
        <ul>
          <li className="app-headline">
            <Link to="/">
              <h1 className="purple-wipe">#BLESSED</h1>
            </Link>
          </li>
          <li className="app-login nav-item">
            <Link to="/login">🔑</Link>
          </li>
        </ul>
      </header>
    );
  }
}

Header.defaultProps = {
  user: {
    email: ''
  },
};

Header.propTypes = {
  user: PropTypes.object,
  authed: PropTypes.any
};

export default Header;



// WEBPACK FOOTER //
// ./client/components/Header.js